module.exports = __webpack_public_path__ + "img/PAD-mgs.7da01c23.png";